/** Enum of LaunchDarkly feature flag names */
export enum Flags {
  ADMIN_HOME_SCREEN = 'adminHomeScreen',
  ADMIN_USERS = 'adminUsers',
  ADMIN_COMPANY_CAMPAIGN = 'adminCompanyCampaign',
  ADMIN_RESOURCES = 'adminResources',
  AI_COMPARE = 'aiCompare',
  AI_RANKING = 'aiRanking',
  AI_RECOMMEND = 'aiRecommend',
  AI_SEARCH = 'aiSearch',
  AUTO_RFQ = 'autoRfq',
  AUTO_RFQ_POST_PROCESSING = 'autoRfqPostProcessing',
  BACKORDERS = 'backorders',
  CATALOG_PRICE_LISTER = 'catalogPriceLister',
  COMPANY_CAMPAIGNS = 'companyCampaigns',
  CONTACTS_GROUPS = 'contactsGroups',
  DIGITAL_SHOWROOM = 'digitalShowroom',
  DIGITAL_SHOWROOM_TELA_BIO_ONE = 'digitalShowroomTelabioOne',
  EMAIL_CAMPAIGNS = 'emailCampaigns',
  EQUIPMENT_FINDER = 'equipmentFinder',
  HOME = 'home',
  INTEGRATIONS = 'integrations',
  INTELLIGENCE_V2 = 'intelligenceV2',
  INVOICES = 'invoices',
  LIVE_HELP = 'liveHelp',
  LOCAL_PRINTER = 'localPrinter',
  MY_FILES = 'myFiles',
  MY_PRESENTATIONS = 'myPresentations',
  ORDERS = 'orders',
  ORDERS_CREATE = 'ordersCreate',
  ORDERS_INSIGHTS = 'ordersInsights',
  ORDERS_REORDER = 'ordersReorder', // Create Order/Due to Reorder, Retention Intelligence
  ORDERS_THREE_PM_REPORT = 'ordersThreePmReport',
  ORDERS_V2 = 'ordersV2',
  OUTBOX = 'outbox',
  OUTBOX_OUTLOOK = 'outboxOutlook',
  OUTLOOK_EMBED_CATALOG = 'outlookEmbedCatalog',
  PDF_ASSISTANT = 'pdfAssistant',
  PRODUCT_ASSISTANT = 'productAssistant',
  PRODUCT_ENHANCER = 'productEnhancer',
  PRODUCT_METADATA = 'productMetadata',
  PRODUCTS_COMPETITOR = 'productsCompetitor',
  PRODUCTS_PRODUCT_MATCH = 'productsProductMatch',
  PRODUCTS_SIMILAR_PRODUCTS = 'productsSimilarProducts',
  PRODUCTS_THREE_SIXTY_VIEW = 'productsThreeSixtyView',
  QUOTE_ORDER_HISTORY = 'quoteOrderHistory',
  QUOTES = 'quotes',
  QUOTES_V2 = 'quotesV2',
  QUOTES_VERSIONING = 'quotesVersioning',
  QUOTE_V2_SHARE_LINK = 'quoteV2ShareLink',
  RESOURCES = 'resources',
  PRODUCTS = 'revopsProducts',
  PRODUCTS_CUSTOMER_VIEW = 'productsCustomerView',
  SALES_ENABLEMENT = 'salesEnablement',
  SETTINGS_NOTIFICATION = 'settingsNotification',
  SNIPPETS = 'snippets',
  TELA_BIO_EVENTS = 'telabioEvents',
  THOUGHTSPOT_LIVEBOARDS = 'thoughtspotLiveboards',
  THOUGHTSPOT_SPOTTER = 'thoughtspotSpotter',
  VENDOR_MATCH = 'vendorMatch',
  WHITESPACE = 'whitespace',
  WHITESPACE_INTELLIGENCE = 'whitespaceIntelligence',
  WORKSPACES = 'workspaces'
}
